import { isFloatString } from 'utils/isFloatString'
import * as Yup from 'yup'

const schema = Yup.object().shape({
  profileId: Yup.string().required('common::validation_messages.required'),
  amount: Yup.string()
    .test(
      'isFloat',
      'common::validation_messages.not_a_number',
      function test(value) {
        const { path, createError } = this

        return (
          isFloatString(value) ||
          createError({
            path,
            message: 'common::validation_messages.not_a_number',
          })
        )
      },
    )
    .required('common::validation_messages.required'),
})

export default schema
